module.exports = __webpack_public_path__ + "static/img/recruit-top.2eab695.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/recruit-top.jpg
// module id = KhWq
// module chunks = 0